// 失车爆料相关路由
import cardRoutes from './card'

export default [
  {
    path: '/report',
    name: 'Report',
    component: () => import('@/views/report'),
    meta: { 
      title: '失车爆料',
      icon: 'bike',
      
    }
  },
  {
    path: '/report/list',
    name: 'ReportList',
    component: () => import('@/views/report/list'),
    meta: { 
      title: '我的爆料',
      icon: 'list',
      
    }
  },
  {
    path: '/report/detail',
    name: 'reportDetail',
    component: () => import('@/views/report/detail'),
    meta: { 
      title: '爆料详情',
      hideInMenu: true,
      
    }
  },
  {
    path: '/report/create',
    name: 'ReportCreate',
    component: () => import('@/views/report/create'),
    meta: { 
      title: '爆料上报',
      hideInMenu: true,
      
    }
  },
  ...cardRoutes
] 